import Phaser from 'phaser';

export default class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload() {
    // 注意：所有真实像素素材都在 PreloadScene 中加载。
    // 这里【不能】再用相同的 key 生成占位纹理 —— Phaser 的
    // TextureManager.checkKey() 遇到已存在的 key 会拒绝覆盖，
    // 从而跳过真实素材的加载，导致游戏里显示的是占位色块。
  }

  create() {
    this.scene.start('PreloadScene');
  }
}
